import React from 'react';
import ParentsInfoForm from 'modules/student/profile/profileForms/Guardian';

const EDUCATION_LEVEL = [
  { label: 'Some high school, no diploma', value: 'nodiploma' },
  { label: 'High school diploma', value: 'highschool' },
  { label: 'Some college credit, no degree', value: 'nodegree' },
  { label: 'Trade/technical/vocational training', value: 'training' },
  { label: 'Associate degree', value: 'associate' },
  { label: 'Bachelor’s degree', value: 'bachelor' },
  { label: 'Master’s degree', value: 'master' },
  { label: 'Doctorate/Professional degree', value: 'professional' },
];

const isJSON = (str) => {
  if (typeof str === 'string') {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {}
  }
  return false;
};

const ParentsInfo = ({ editable, student, profile: { guardians } }) => {
  return <ParentsInfoForm user={student} editable={editable} />;
};

export default ParentsInfo;
